import "bootstrap/dist/css/bootstrap.min.css";
import {
  Switch,
  useHistory,
  Route,
  BrowserRouter as Router,
  Redirect,
} from "react-router-dom";
import Forgot from "./Components/Forgot";
import Login from "./Components/Login";
import Register from "./Components/Register";
import Dashboard from "./Components/Dashboard";
import Landing from "./Components/Landing";

import Mainlanding from "./Components/Mainpage/Mainlanding";

import AdminLogin from "./Components/admin/AdminLogin";
// import Setting from './Components/admin/Settings';
import ChangePassword from "./Components/admin/ChangePassword";
import WithdrawalRequests from "./Components/admin/WithdrawalRequests";
import CreateAirdrop from "./Components/admin/CreateAirdrop";
import UpdateAirdrop from "./Components/admin/UpdateAirdrop";
import Airdrop from "./Components/admin/Airdrop";
import Mint from "./Components/Mint";
import { StateProvider } from "./StateProvider.js";
import { reducer, initialState } from "./reducer.js";
import Profile from "./Components/Profile";
import Stake from "./Components/Stake";
import Matic from "./Components/Matic";

// import { Moblanding } from "./Mobile/Moblanding";

function App() {
  const history = useHistory();
  return (
    <>
      {/* <div style={{textAlign:"center",fontWeight:"bold",paddingTop:"40px"}}>This Website is under maintenance</div> */}
      <StateProvider initialState={initialState} reducer={reducer}>
        <Router basename={"/"} history={history}>
          <Switch>
            <Route
              exact
              path="/"
              render={() => {
                return <Redirect to="/home" />;
              }}
            />
            <Route exact path="/little-token" component={Landing} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/register" component={Register} />
            <Route exact path="/dashboard" component={Dashboard} />
            <Route exact path="/forgot" component={Forgot} />
            <Route exact path="/home" component={Mainlanding} />
            <Route exact path="/mint" component={Mint} />
            <Route exact path="/profile" component={Profile} />
            <Route exact path="/stake" component={Stake} />
            <Route exact path="/matic" component={Matic} />
            {/* <Route exact path="/moblanding" component={Moblanding} /> */}
            {/* <Route exact path="/main-landing" component={Mainlandingmob} /> */}

            <Route exact path="/admin/login" component={AdminLogin} />
            <Route
              exact
              path="/admin/change_password"
              component={ChangePassword}
            />
            <Route
              exact
              path="/admin/withdrawal_requests"
              component={WithdrawalRequests}
            />
            <Route
              path="/admin/create_airdrop"
              exact
              component={CreateAirdrop}
            />
            <Route
              path="/admin/update_airdrop"
              exact
              component={UpdateAirdrop}
            />
            <Route path="/admin/airdrops" exact component={Airdrop} />
          </Switch>
        </Router>
      </StateProvider>
    </>
  );
}
export default App;
